export default __webpack_public_path__ + "static/media/table7seatDiagonal.972c4ab1.svg";